import { ButtonHTMLAttributes } from "react";
import { cx } from "./classNames";

type ButtonVariant = "primary" | "secondary" | "ghost";
type ButtonSize = "sm" | "md" | "lg";

const variantClassMap: Record<ButtonVariant, string> = {
  primary:
    "bg-brand-accent text-white border border-transparent hover:bg-brand-accent-strong shadow-md",
  secondary: "bg-brand-surface text-brand-ink border border-black/10 hover:bg-black/5",
  ghost:
    "bg-transparent text-brand-muted border border-transparent hover:bg-black/5 hover:text-brand-ink",
};

const sizeClassMap: Record<ButtonSize, string> = {
  sm: "px-3 py-1.5 text-xs",
  md: "px-4 py-2 text-sm",
  lg: "px-6 py-3 text-sm",
};

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  rounded?: "pill" | "xl";
}

export function Button({
  className,
  variant = "primary",
  size = "md",
  rounded = "pill",
  type = "button",
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={cx(
        "font-semibold transition-all duration-150 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-2 focus-visible:ring-offset-brand-surface motion-reduce:transition-none motion-reduce:transform-none",
        rounded === "pill" ? "rounded-full" : "rounded-xl",
        variantClassMap[variant],
        sizeClassMap[size],
        className,
      )}
      {...props}
    />
  );
}
